import {createAction} from '@reduxjs/toolkit'

export const clearInvoice = createAction('CLEAR_INVOICE')
